export type ModelFilterDropdownItem = {
  label: string;
  value: string[];
};

export const ModelFilterDropdown: ModelFilterDropdownItem[] = [
  {
    label: "Water",
    value: [
      "tag.rhw",
      "tag.wmd",
      "tag.h2o",
      "lora.wmd",
      "lora.irrigator",
      "bulk.wmd",
      "rom.ptw",
    ],
  },
  {
    label: "Electricity",
    value: [
      "tag.rhe",
      "tag.opt",
      "lte.opt",
      "lora.abbelec",
      "rom.pte",
      "rom.rhe",
    ],
  },
  {
    label: "Temperature",
    value: ["tag.tmp", "tag.tmo", "lora.nanotag", "lora.tmp", "shv.tmp"],
  },
  {
    label: "Gas",
    value: ["tag.dry", "stron.gas"],
  },
  {
    label: "Level",
    value: ["tag.lvl"],
  },
  {
    label: "Gateways",
    value: ["lora.gateway"],
  },
  {
    label: "QR Code",
    value: ["qrw.man", "qre.man", "qre.pre", "qrw.pre", "qrg.pre"],
  },
  {
    label: "Humidity",
    value: ["lora.humidity"],
  },
];
